import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";

export interface DropdownProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  asChild?: boolean;
  optionList: string[];
  id: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
}

const Dropdown = React.forwardRef<HTMLDivElement, DropdownProps>(
  (
    { className, asChild = false, optionList, id, defaultValue, onChange, ...props },
    ref
  ) => {
    const Comp = asChild ? Slot : "div";

    return (
      <Comp
        className={cn("font-bold ml-2", className)}
        ref={ref}
        {...props}
      >
        <select
          id={id}
          name={id}
          defaultValue={defaultValue} // Set default value
          onChange={(e) => onChange?.(e.target.value)} // Trigger onChange
          className="appearance-none outline-0 cursor-pointer pr-5 max-w-32 md:max-w-48 truncate bg-[url('/icon/arrow_down.svg')] bg-no-repeat bg-right"
        >
          {optionList.map((element) => (
            <option key={element} value={element}>
              {element}
            </option>
          ))}
        </select>
      </Comp>
    );
  }
);

Dropdown.displayName = "Dropdown";

export { Dropdown };
